




























































import { Component, Inject, Mixins } from "vue-property-decorator";
import { IAffiliateProvider } from "@/models/providers/affiliate";
import Context from "@/mixins/context";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class AffiliateStatsGrid extends Mixins(Context) {
  // Inject

  @Inject({ from: "affiliateProvider" })
  public readonly affiliateProvider!: () => IAffiliateProvider;

  // Computed

  public get $affiliateData() {
    return this.affiliateProvider();
  }
}
